"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./HorizontalLabel.module.css"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var HorizontalLabel = (function (_super) {
    __extends(HorizontalLabel, _super);
    function HorizontalLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.helpVisible = false;
        return _this;
    }
    HorizontalLabel.prototype.render = function () {
        var _a = this.props, error = _a.error, help = _a.help, text = _a.text, required = _a.required, htmlFor = _a.htmlFor, className = _a.className;
        return (React.createElement(React.Fragment, null,
            React.createElement("label", { className: className ? className : styles.root, htmlFor: htmlFor },
                text,
                required && React.createElement("span", null, "*"),
                help && React.createElement("small", { style: { display: "block" } }, help)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    __decorate([
        mobx_1.observable
    ], HorizontalLabel.prototype, "helpVisible", void 0);
    HorizontalLabel = __decorate([
        mobx_react_1.observer
    ], HorizontalLabel);
    return HorizontalLabel;
}(react_1.Component));
exports.HorizontalLabel = HorizontalLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSG9yaXpvbnRhbExhYmVsLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9Ib3Jpem9udGFsTGFiZWwvSG9yaXpvbnRhbExhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUMvQixtRUFBc0Q7QUFDdEQseUNBQW1DO0FBQ25DLDZCQUErQjtBQVkvQjtJQUFxQyxtQ0FBOEI7SUFJL0QseUJBQVksS0FBSztRQUFqQixZQUNJLGtCQUFNLEtBQUssQ0FBQyxTQUNmO1FBSk8saUJBQVcsR0FBRyxLQUFLLENBQUE7O0lBSTNCLENBQUM7SUFDTSxnQ0FBTSxHQUFiO1FBQ1UsSUFBQSxlQUE4RCxFQUE3RCxnQkFBSyxFQUFFLGNBQUksRUFBRSxjQUFJLEVBQUUsc0JBQVEsRUFBRSxvQkFBTyxFQUFFLHdCQUF1QixDQUFBO1FBRXBFLE9BQU8sQ0FDSCxvQkFBQyxLQUFLLENBQUMsUUFBUTtZQUNYLCtCQUFPLFNBQVMsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTztnQkFDbEUsSUFBSTtnQkFDSixRQUFRLElBQUksc0NBQWM7Z0JBQzFCLElBQUksSUFBSSwrQkFBTyxLQUFLLEVBQUUsRUFBQyxPQUFPLEVBQUUsT0FBTyxFQUFDLElBQUcsSUFBSSxDQUFTLENBQ3JEO1lBQ1AsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ3JDLENBQ3BCLENBQUE7SUFDTCxDQUFDO0lBbEJEO1FBREMsaUJBQVU7d0RBQ2dCO0lBRmxCLGVBQWU7UUFEM0IscUJBQVE7T0FDSSxlQUFlLENBcUIzQjtJQUFELHNCQUFDO0NBQUEsQUFyQkQsQ0FBcUMsaUJBQVMsR0FxQjdDO0FBckJZLDBDQUFlIn0=